import { Injectable } from '@angular/core';
import * as myGlobals from '../app.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  private baseUrl = myGlobals.baseUrl;

  constructor(private http: HttpClient) { }

  headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('authorization', 'Bearer ' + localStorage.getItem('token'));

  options = { headers: this.headers };

  getInstitutesList() {
    return this.http.get(`${this.baseUrl}/getInstitutesList`);
  }

  getRegistrationDetails() {
    return this.http.get(`${this.baseUrl}/getRegistrationDetails`);
  }

  getRegDesignation(data) {
    return this.http.get(`${this.baseUrl}/getRegDesignations?id=` + data);
  }

  submitRegistration(data) {
    return this.http.post(`${this.baseUrl}/submitRegistration`, data);
  }

  getDetails(data) {
    return this.http.get(`${this.baseUrl}/getStudentRegistrationDetails?email=` + data);
  }

  SubmitStudentRegistration(data) {
    return this.http.post(`${this.baseUrl}/studentRegister`, data);
  }

  fetchDepartments(stream_id) {
    return this.http.get(`${this.baseUrl}/fetchDepartments?stream_id=` + stream_id);
  }
}
